import {config} from './config'
import Cookies from 'js-cookie'

const mode = Cookies.get('themeMode') ?? config('settings.theme.mode')

export default {
    dark: mode === 'dark',
    options: {
        customProperties: true
    },
    themes: {
        [mode]: config('settings.theme.colors')
    }
}
